import { render, staticRenderFns } from "./ComplimentView.vue?vue&type=template&id=53970ba6&scoped=true"
import script from "./ComplimentView.vue?vue&type=script&lang=js"
export * from "./ComplimentView.vue?vue&type=script&lang=js"
import style0 from "./ComplimentView.vue?vue&type=style&index=0&id=53970ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53970ba6",
  null
  
)

export default component.exports